import React from "react";
import { FormControlLabel, Grid, Switch } from "@mui/material";

import GridListItem from "components/common/grid/GridListItem";
import { capitalizeFirstLetterOfEachWord } from "utils/string";
import { isValidArray } from "utils/array";
import { formatDateTime } from "utils/date";
import { DATE_FORMAT } from "static/date";

const CiedDeviceInformationPreviewItem = ({
  deviceInformation,
  isPreviousDevices = false,
  isCombinedDevices = false,
  onSelected,
  selectedDevice,
  isSubmitting,
  hasPreviousDevice,
}) => {
  const {
    doi,
    account,
    modelName,
    modelNumber,
    manufacturer,
    mriCompatible,
    alertDeviceText,
    implanting_physicians,
    device_type,
  } = deviceInformation || {};

  return (
    <>
      <Grid container item sm={isCombinedDevices ? 7 : 6}>
        {isCombinedDevices && (
          <FormControlLabel
            control={
              <Switch
                name="toggle_duplicate"
                onChange={() => {
                  onSelected(deviceInformation);
                }}
                checked={
                  selectedDevice?.device_model === modelName &&
                  selectedDevice?.device_serial === modelNumber
                }
                disabled={
                  isSubmitting ||
                  (!hasPreviousDevice &&
                    deviceInformation?.device_type === "Primary")
                }
              />
            }
          />
        )}

        {isCombinedDevices &&
          Object?.hasOwn(deviceInformation, "device_type") && (
            <GridListItem
              title="DEVICE TYPE"
              subTitle={device_type ?? "—"}
              size={2}
            />
          )}

        <GridListItem
          title="ACCOUNT"
          subTitle={account ?? "—"}
          size={isCombinedDevices ? 3 : 4}
        />

        <GridListItem
          title="MANUFACTURER"
          subTitle={manufacturer ?? "—"}
          size={3}
        />

        <GridListItem
          title="MODEL NAME"
          subTitle={modelName ?? "—"}
          size={isCombinedDevices ? 3 : 4}
        />
      </Grid>

      <Grid container item sm={5}>
        <GridListItem
          title="SERIAL NUMBER"
          subTitle={modelNumber ?? "—"}
          size={4}
        />

        <GridListItem
          title="DATE OF IMPLANT"
          subTitle={doi ? formatDateTime(doi, DATE_FORMAT.DEFAULT) : "—"}
          size={4}
        />

        <GridListItem
          title="IMPLANTING PHYSICIAN"
          subTitle={
            isValidArray(implanting_physicians)
              ? implanting_physicians?.join(", ")
              : "—"
          }
          size={4}
        />
      </Grid>

      {!isPreviousDevices && (
        <>
          <Grid container item sm={6}>
            <GridListItem
              title="MRI COMPATIBLE"
              subTitle={
                mriCompatible
                  ? capitalizeFirstLetterOfEachWord(mriCompatible.toString())
                  : "—"
              }
              size={4}
            />

            <GridListItem
              title="DEVICE ALERT"
              subTitle={alertDeviceText ?? "—"}
              size={4}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default CiedDeviceInformationPreviewItem;
